import React, { useState } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import person1 from "../../assets/img/person1.png";
import leftarrow from "../../assets/img/leftarrow.png";
import rightarrow from "../../assets/img/rightarrow.png";

const feedbacks = [
  {
    name: "Vijaya Kumar",
    feedback: "Best Delivery Services Across Bhubaneswar",
  },
  {
    name: "Anita Mishra",
    feedback: "Highly professional team and timely services",
  },
  { name: "Rajesh Singh", feedback: "Excellent support and quick responses" },
];

function FeedbackBanner() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? feedbacks.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === feedbacks.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column", // Column layout on small screens (mobile)
          sm: "column", // Column layout on tablets
          md: "row", // Row layout on medium to large screens
        },
        justifyContent: "space-around",
        alignItems: "center",
        padding: {
          xs: "2rem 2rem", // Smaller padding for mobile screens
          sm: "3rem 3rem",
          md: "4rem 5rem", // Larger padding for desktop
        },
        minHeight: {
          xs: "500px", // Increased height for mobile screens
          sm: "500px",
          md: "300px",
        },
        backgroundColor: "#fff",
        marginTop: "15vh",
      }}
    >
      {/* Left Side - Feedback Text */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          marginBottom: {
            xs: "2rem", // Add margin on mobile to separate content
            sm: "2rem",
            md: 0, // No margin for larger screens
          },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(to right, #6e6e6e, #0096FF)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "1rem",
            fontSize: {
              xs: "2rem", // Smaller font size on mobile screens
              sm: "2.5rem",
              md: "3rem", // Larger font size on desktop
            },
          }}
        >
          Feedback
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(to right, #6e6e6e, #0096FF)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: {
              xs: "2rem", // Smaller font size on mobile screens
              sm: "2.5rem",
              md: "3rem", // Larger font size on desktop
            },
          }}
        >
          From Our Top Clients
        </Typography>
      </Box>

      {/* Right Side - Feedback Card */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column", // Column layout for mobile
            sm: "column", // Column layout for tablets
            md: "row", // Row layout for desktops
          },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Prev Button (Left Arrow) */}
        <Button
          onClick={handlePrev}
          sx={{
            minWidth: "60px",
            fontSize: "16px",
            color: "#000",
            textTransform: "capitalize",
            marginBottom: {
              xs: "1rem", // Add margin between buttons and cards on mobile
              sm: "1rem",
              md: 0,
            },
          }}
        >
          <img
            src={leftarrow}
            alt="Previous"
            style={{
              width: "40px", // Increased arrow size
              height: "40px",
              transform: "rotate(180deg)", // Rotate left arrow by 180 degrees
            }}
          />
        </Button>

        {/* Feedback Card */}
        <Card
          sx={{
            width: {
              xs: "90%", // Card takes up more width on mobile
              sm: "80%",
              md: "500px",
            },
            height: {
              xs: "350px", // Increased height for mobile screens
              sm: "350px",
              md: "280px",
            },
            background: "linear-gradient(180deg, #D9D9D9 0%, #197BC5 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            borderRadius: "10px",
            margin: {
              xs: "1rem 0", // Margin around the card for mobile
              sm: "1rem 0",
              md: "0 1rem",
            },
          }}
        >
          {/* Avatar Placeholder */}
          <Box
            sx={{
              width: "50px",
              height: "50px",
              backgroundColor: "#fff",
              borderRadius: "50%",
              marginBottom: "1rem",
              overflow: "hidden",
            }}
          >
            <img
              src={person1}
              alt="Person Avatar"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          <CardContent>
            <Typography
              variant="h6"
              sx={{
                color: "#fff",
                textAlign: "center",
                fontSize: {
                  xs: "1rem", // Smaller font size on mobile
                  sm: "1.2rem",
                  md: "1.5rem",
                },
              }}
            >
              {feedbacks[currentIndex].name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#fff", textAlign: "center" }}
            >
              "{feedbacks[currentIndex].feedback}"
            </Typography>
          </CardContent>
        </Card>

        {/* Next Button (Right Arrow) */}
        <Button
          onClick={handleNext}
          sx={{
            minWidth: "60px",
            fontSize: "16px",
            color: "#000",
            textTransform: "capitalize",
            marginTop: {
              xs: "1rem", // Margin for mobile screen
              sm: "1rem",
              md: 0,
            },
          }}
        >
          <img
            src={rightarrow}
            alt="Next"
            style={{
              width: "40px", // Increased arrow size
              height: "40px",
            }}
          />
        </Button>
      </Box>
    </Box>
  );
}

export default FeedbackBanner;
